import styles from './InTheBag.module.scss';
import GreenCheckmarkIcon from '@/assets/icons/green-checkmark.svg?react';
import DashedSquareIcon from '@/assets/icons/dashed-square.svg?react';
import { isMobileResolution } from '@/utils';

interface ISetClubsProps {
  amount: number;
  className?: string;
  squareIcon?: boolean;
}

export default function SetClubs({ amount, className = '', squareIcon = false }: ISetClubsProps) {
  return (
    <div className={`${styles.inTheBag} ${className}`}>
      {!squareIcon && <GreenCheckmarkIcon className={styles.icon} />}
      {squareIcon && <DashedSquareIcon className={styles.icon} />}
      <span className={styles.label}>
        {amount} {isMobileResolution ? 'In' : 'In bag'}
      </span>
    </div>
  );
}
